import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

import type { SupportedAppLanguage } from '../../types';

export const languages = import.meta.glob('../../../../translations/*.json');

export const useLoadLanguages = () => {
  const { locale, setLocaleMessage, getLocaleMessage } = useI18n();

  const switchLocale = (newLocale: SupportedAppLanguage) => {
    locale.value = newLocale;
  };

  watch(
    locale,
    async (newLocale) => {
      if (!Object.keys(getLocaleMessage(newLocale)).length) {
        const messages = (await languages[`../../../../translations/${newLocale}.json`]()) as {
          default: Record<string, string>;
        };

        setLocaleMessage(newLocale, messages.default);
      }
    },
    { immediate: true },
  );

  return {
    switchLocale,
  };
};
